import { Component, OnInit, ViewRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../_alert';
import { NgxSpinnerService } from 'ngx-spinner';
import { DepartmentService } from '../../services/jrni/department.service';
import { DatastoreService } from '../../services/datastore.service';
import { ServicesService } from '../../services/jrni/services.service';
import { TranslateService } from '@ngx-translate/core';
import { BasketService } from '../../services/jrni/basket.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { context } from 'bookingbug-core-js';
import { BookingService } from '../../services/jrni/booking.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MemberService } from '../../services/jrni/member.service';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/jrni/api.service';
import { ceremonyFeeTotal } from '../../services/citizenship-capacity';
import { UntypedFormBuilder } from '@angular/forms';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { ConfigService } from "../../services/config.service";
import moment from "moment-timezone";
import { AppConfig } from "../../app.config";
import { BarnsleyImsService } from '../../services/barnsley-ims.service';
import { QuestionsService } from '../../services/questions.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-verify-payment',
  templateUrl: './verify-payment.component.html',
  styleUrls: ['./verify-payment.component.scss']
})
export class VerifyPaymentComponent implements OnInit {

  scpId: any = null;
  bookingId: any = null;
  paymentId: any = null;
  companyId: any = null;
  pageTitle: string;
  verifyPageText: string;
  selectedSlot: any;
  selectedService: any;
  selectedLocation: any;
  purchase: any;
  selectedBooking: any;
  company: any;
  booking: any;
  member: any;
  parent: any;
  config: any;
  basket: string;
  serviceItems: string[];
  amount: any;
  receiptId: string;
  bookingMade = false;
  retries = 100;
  maxRetriesReached = false;
  isCitizenship = false;
  paymentFailed = false;
  paymentAlreadyPaid = false;
  nr: any = window['newrelic'];
  webhookResponseStatus = '';
  chargeId = '';
  receipt = '';
  ref = '';
  failed = false;
  // BMBC IMS: payment confirmed (PaymentAuthorisationCode 00000) but the
  // server-side post-basket worker has not surfaced the JRNI purchase on the
  // pre-basket row — show "payment received" rather than strand the user.
  paymentReceived = false;
  failureDescription = '';

  constructor(
    private router: Router,
    private departmentService: DepartmentService,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private datastoreService: DatastoreService,
    private barnsleyImsService: BarnsleyImsService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private servicesService: ServicesService,
    private basketService: BasketService,
    private http: HttpClient,
    private bookingService: BookingService,
    private memberService: MemberService,
    private apiService: ApiService,
    private formBuilder: UntypedFormBuilder,
    private availabilityService: AvailabilityService,
    private questionsService: QuestionsService
  ) { }

  async ngOnInit() {
    this.spinner.show();

    let configCompanyId = AppConfig.settings.core.company_id;
    if (this.datastoreService.isCitizenshipRoute) {
      configCompanyId = AppConfig.settings.core.citizenship_company_id;
    }

    // this.dataStore.checkShouldHideNavigation();
    const appConfig: any = await this.apiService.getConfig(configCompanyId);
    this.config = appConfig;

    this.datastoreService.config = appConfig;
    console.log('config');
    console.log(this.config);
    if (this.config.hasOwnProperty('journey_config')) {
      if (this.config.journey_config.hasOwnProperty('appointments')) {
        if (this.config.journey_config.appointments.hasOwnProperty('payment_verify_retries')) {
          this.retries = parseInt(this.config.journey_config.appointments.payment_verify_retries);
          console.log(`Retries set to ${this.retries}`);
        }
      }
    }

    // set page content to default

    const content = this.config?.journey_config?.appointments?.page_content?.["default"];
    this.datastoreService.pageContent = content;

    this.route.params.subscribe(async (params) => {
      console.log('url params');
      console.log(params);
      if (params.basket) {
        this.basket = params.basket;
      }
      if (params.serviceItems) {
        this.serviceItems = params.serviceItems.split(',');
      }
      if (params.company) {
        this.companyId = params.company;
      }
      if (this.basket && this.serviceItems.length > 0) {
        // BMBC IMS redirects to back_url on failure/cancel with the payment
        // result appended — PaymentAuthorisationCode !== '00000' means no money
        // was taken. Free the slot and show the gateway's outcome with a
        // restart link (rather than the silent restart of the bare
        // ?cancelled=true marker, which would hide a card decline).
        const imsAuthCode = this.route.snapshot.queryParams['PaymentAuthorisationCode'];
        if (imsAuthCode && imsAuthCode !== '00000') {
          this.pageTitle = 'Your payment was not completed';
          this.failed = true;
          this.failureDescription = this.route.snapshot.queryParams['ResponseDescription'] || '';
          this.chargeId = imsAuthCode;
          this.ref = this.route.snapshot.queryParams['CallingApplicationTransactionReference'] || '';
          try {
            await this.apiService.deleteBaskets({ id: this.companyId });
          }
          catch (err) {
            console.warn('Could not clear basket after failed payment:', err);
          }
          this.basketService.currentBasket = null;
          this.spinner.hide();
          return;
        }
        // NRPO-38: The user selected the "Back"/Cancel button on the payment
        // gateway and it redirected to our back_url, which we tag with ?cancelled=true
        // (a successful payment returns to the same page with no such marker), so
        // the user would otherwise get stuck on the "Verifying payment" spinner.
        // Clear the current basket and restart the journey on the landing page.
        if (this.route.snapshot.queryParams['cancelled']) {
          const authToken: string = localStorage.getItem('auth_token');
          try {
            await this.apiService.deleteBaskets({ id: this.companyId });
          }
          catch (err) {
            console.warn('Could not clear basket on payment cancel/back:', err);
          }
          this.basketService.currentBasket = null;
          if (localStorage.getItem('agent') && authToken) {
            // Agent/telephony journey: return to the admin services page.
            window.location.assign(`/services?admin-only=true&auth_token=${authToken}`);
          }
          else {
            // Public journey: return to the landing page for the journey they were on.
            const journey = sessionStorage.getItem('journey');
            window.location.assign(journey ? `/start/${journey}` : `/start`);
          }
          return;
        }
        console.log('begin verify');
        this.route.params.subscribe(params => {
          this.pageTitle = 'Verifying payment';

          this.departmentService.getParentDepartment().then(async dept => {
            console.log('parent1');
            console.log(this.parent);
            this.parent = dept;
            const originalChildren = await this.departmentService.getChildDepartments(dept);
            for (const location of originalChildren) {
              if (location.id == this.companyId) {
                this.company = location;
                await this.departmentService.setLocation(location);
                this.selectedLocation = location;
                break;
              }
            }

            console.log('location1');
            console.log(this.selectedLocation);
            if (!this.selectedLocation) {
              this.datastoreService.isCitizenshipRoute = true;
              this.parent = await this.departmentService.getParentDepartment();
              console.log('parent2');
              console.log(this.parent);
              const children = await this.departmentService.getChildDepartments(this.parent);
              for (const location of children) {
                console.log('child2');
                console.log(location);
                if (location.id == this.companyId) {
                  this.company = location;
                  await this.departmentService.setLocation(location);
                  this.selectedLocation = location;

                  // redo the config
                  this.apiService.configCache = {};
                  const appConfig: any = await this.apiService.getConfig(this.parent.id);
                  this.config = appConfig;

                  console.log('this.config?.journey_config?');
                  console.log(this.config?.journey_config);
                  const content = this.config?.journey_config?.appointments?.page_content?.["default"];
                  this.datastoreService.pageContent = content;

                  this.datastoreService.config = appConfig;
                  if (this.config.hasOwnProperty('journey_config')) {
                    if (this.config.journey_config.hasOwnProperty('appointments')) {
                      if (this.config.journey_config.appointments.hasOwnProperty('payment_verify_retries')) {
                        this.retries = parseInt(this.config.journey_config.appointments.payment_verify_retries);
                        console.log(`Retries set to ${this.retries}`);
                      }
                    }
                  }
                  break;
                }
              }
            }
            console.log('location2');
            console.log(this.selectedLocation);
            console.log('params', this.route.snapshot.params);

            if (params['basket'] && params['serviceItems']) {
              // test
              for (const serviceItem of this.serviceItems) {
                try {
                  if (serviceItem) {
                    console.log('serviceItem');
                    console.log(serviceItem);
                    console.log('cid');
                    console.log(this.companyId);
                    const purchase: any = await this.barnsleyImsService.preBasketFind(this.companyId, this.basket, serviceItem);

                    if (purchase) {
                      if (purchase.status !== 'PAID') {
                        if (purchase.data && purchase.data.client_id) {
                          //  now we update the details

                          if (purchase.data && purchase.data.extra_items && purchase.data.extra_items.lookupResponses) {
                            this.datastoreService.lookupResponses = purchase.data.extra_items.lookupResponses;
                          }

                          if (purchase.data && purchase.data.extra_items && purchase.data.extra_items.selectedAddress) {
                            this.datastoreService.selectedAddress = purchase.data.extra_items.selectedAddress;
                          }

                          if (purchase.data && purchase.data.auth_token) {
                            localStorage.setItem('auth_token', purchase.data.auth_token);
                          }
                          if (purchase.data.journey_route) {
                            this.datastoreService.journeyRoute = purchase.data.journey_route;
                            const content = this.config?.journey_config?.appointments?.page_content?.[purchase.data.journey_route];
                            this.datastoreService.pageContent = content;

                          }
                          // await this.getCompanyQuestions(purchase.data.detail_group);
                          this.selectedSlot = purchase.data.slot;
                          this.datastoreService.extraDuration = purchase.data.extra_duration;
                          await this.availabilityService.setSelectedSlot(this.selectedSlot);
                          const imsQueryParams = this.route.snapshot.queryParams;
                          purchase.data.auth_code = imsQueryParams['PaymentAuthorisationCode'];
                          purchase.data.receipt = imsQueryParams['IncomeManagementReceiptNumber'];
                          this.receiptId = purchase.data.receipt;
                          // const update: any = await this.barnsleyImsService.preBasketUpdate(this.companyId, this.basket, serviceItem, 'RETURNED_FROM_GATEWAY', purchase.data.receipt, purchase.data);
                          // console.log('update');
                          // console.log(update);
                          // this.datastoreService.serviceFees = update.data.extra_items.fees;
                          // // now we checkout
                          // const checkout: any = await this.apiService.basketCheckout({ id: this.companyId }, { id: this.basket }, { id: purchase.data.client_id });
                          // console.log('checkout');
                          // console.log(checkout);
                          // await this.afterCheckout(checkout, serviceItem, purchase);
                          // BMBC IMS: '00000' means the money is taken and the
                          // booking is being created server-side (n8n post-basket).
                          const imsPaid = imsQueryParams['PaymentAuthorisationCode'] === '00000';
                          let handedOffTicks = 0;
                          const source = interval(2000);
                          const sub = source.subscribe(async (val) => {
                            console.log(`Run ${val}`);
                            if (val < this.retries) {
                              if (!this.bookingMade) {
                                try {
                                  const found:any = await this.barnsleyImsService.preBasketFind(this.companyId, this.basket, serviceItem);
                                  console.log('found in interval', found);
                                  this.webhookResponseStatus = `COMMON.${found.status}`;
                                  if (found.data) {
                                    if (found.data.auth_code) {
                                      this.chargeId = found.data.auth_code;
                                    }
                                    if (found.ref) {
                                      this.ref = found.ref;
                                    }
                                    if (found.data.receipt) {
                                      this.receipt = found.data.receipt;
                                    }

                                  }
                                  if (!this.chargeId) {
                                    if (imsQueryParams['PaymentAuthorisationCode']) {
                                      this.chargeId = imsQueryParams['PaymentAuthorisationCode'];
                                    }
                                  }
                                  if (!this.receipt) {
                                    if (imsQueryParams['IncomeManagementReceiptNumber']) {
                                      this.receipt = imsQueryParams['IncomeManagementReceiptNumber'];
                                    }
                                  }

                                  if (found.status === 'PAID' && found.data && found.data.purchase_id) {
                                    sub.unsubscribe();
                                    const purchase:any = await this.apiService.findPurchase(this.selectedLocation, found.data.purchase_id);
                                    const booking = purchase._embedded.bookings[0];
                                    this.datastoreService.booking = booking;
                                    const service = await this.apiService.getService(this.selectedLocation, booking.service_id);
                                    this.selectedService = service;
                                    this.datastoreService.selectedService = service;
                                    await this.servicesService.set(service);

                                    localStorage.setItem('booking', JSON.stringify(booking));
                                    // set the resource, the date time and the location, the booking all on localstorage
                                    // localStorage.setItem('resource', JSON.stringify(this.selectedResourceObj));
                                    localStorage.setItem('date', JSON.stringify(this.selectedSlot));
                                    localStorage.setItem('location', JSON.stringify(this.selectedLocation));
                                    localStorage.setItem('service', JSON.stringify(this.selectedService));

                                    this.router.navigate(['confirmation']);
                                  }
                                  else if (imsPaid && (found.status === 'HANDED_OFF' || found.status === 'PAID')) {
                                    // The gateway has handed the paid booking to the
                                    // post-basket worker. Give it a few ticks to record
                                    // the JRNI purchase on the row; if it doesn't
                                    // surface, the payment still stands (00000 = paid),
                                    // so show "payment received" rather than an error.
                                    handedOffTicks++;
                                    if (handedOffTicks >= 5) {
                                      sub.unsubscribe();
                                      this.pageTitle = 'Payment received';
                                      this.webhookResponseStatus = '';
                                      this.paymentReceived = true;
                                      this.spinner.hide();
                                    }
                                  }

                                  if (found.status.indexOf('ERR_') !== -1 || found.status.indexOf('FAILED') !== -1) {
                                    sub.unsubscribe();
                                    this.spinner.hide();
                                    this.webhookResponseStatus = '';
                                    this.pageTitle = 'Your payment was not completed';
                                    this.failed = true;
                                  }

                                }
                                catch (err) {
                                  console.error(err);
                                }

                                // if (found.status === 'BOOKING_MADE') {
                                //   console.log('Booking made!');
                                //   this.bookingMade = true;
                                //   const checkout:any = await this.apiService.findPurchase({id: this.companyId}, found.data.purchase_id);
                                //   this.afterCheckout(checkout, serviceItem, found);
                                // }
                              }
                            }
                            else {
                              console.error(`Retry limit of ${this.retries} reached`);
                              sub.unsubscribe();
                              if (imsPaid) {
                                // Money was taken — never show an error for a paid booking.
                                this.pageTitle = 'Payment received';
                                this.webhookResponseStatus = '';
                                this.paymentReceived = true;
                              }
                              else {
                                this.alertService.error(
                                  this.translateService.instant('COMMON.PAYMENT_MAX_RETRIES_REACHED', {serviceId: imsQueryParams['IncomeManagementReceiptNumber']})
                                );
                                this.maxRetriesReached = true;
                              }
                              this.spinner.hide();
                            }
                          });
                        }
                        else {
                          console.error(`No client found for ${this.basket} and ${serviceItem}`);
                        }
                      }
                      else {
                        this.pageTitle = "Your purchase has already been paid";
                        this.paymentAlreadyPaid = true;
                        this.paymentFailed = true;
                        this.spinner.hide();
                        console.warn(`Purchase already paid`);
                      }
                    }
                    else {
                      console.error(`No purchase found for ${this.basket} and ${serviceItem}`);
                    }
                  }
                }
                catch (err) {
                  console.error(err);
                  this.spinner.hide();
                  this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
                }

              }
            }
            else {
              if (params['Rc'] && params['Rc'] !== 'A') {
                this.pageTitle = "Your payment and booking has been cancelled";
                this.paymentFailed = true;


                for (const serviceItem of this.serviceItems) {
                  try {
                    if (serviceItem) {
                      console.log('serviceItem', serviceItem);
                      console.log('cid', this.companyId);
                      const purchase: any = await this.barnsleyImsService.preBasketFind(this.companyId, this.basket, serviceItem);

                      if (purchase) {
                        if (purchase.data && purchase.data.client_id) {
                          //  now we update the details

                          if (purchase.data && purchase.data.extra_items && purchase.data.extra_items.lookupResponses) {
                            this.datastoreService.lookupResponses = purchase.data.extra_items.lookupResponses;
                          }

                          if (purchase.data && purchase.data.extra_items && purchase.data.extra_items.selectedAddress) {
                            this.datastoreService.selectedAddress = purchase.data.extra_items.selectedAddress;
                          }

                          if (purchase.data && purchase.data.auth_token) {
                            localStorage.setItem('auth_token', purchase.data.auth_token);
                          }
                          if (purchase.data.journey_route) {
                            this.datastoreService.journeyRoute = purchase.data.journey_route;
                            const content = this.config?.journey_config?.appointments?.page_content?.[purchase.data.journey_route];
                            this.datastoreService.pageContent = content;

                          }
                          // await this.getCompanyQuestions(purchase.data.detail_group);
                          this.selectedSlot = purchase.data.slot;
                          this.datastoreService.extraDuration = purchase.data.extra_duration;
                          // await this.availabilityService.setSelectedSlot(this.selectedSlot);
                          purchase.data.auth_code = params['AuthCode'];
                          purchase.data.receipt = params['RecNo'];
                          this.receiptId = purchase.data.receipt;
                          const update: any = await this.barnsleyImsService.preBasketUpdate(this.companyId, this.basket, serviceItem, 'PAYMENT_FAILED', purchase.data.receipt, purchase.data);
                          console.log('updated', update);
                        }
                        else {
                          console.error(`No client found for ${this.basket} and ${serviceItem}`);
                        }
                      }
                      else {
                        console.error(`No purchase found for ${this.basket} and ${serviceItem}`);
                      }
                    }
                  }
                  catch (err) {
                    console.error(err);
                    this.spinner.hide();
                    this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
                  }
                }

                console.error(`Purchase was not successful for ${this.basket}.`);
                this.spinner.hide();
              }
            }

            // Telephony
            if (params['return']) {
              console.log('This is an ARP payment return');
              if (params['payResult']) {
                if (params['payResult'] === 'Authorised') {
                  this.datastoreService.adminJourney = true;
                  console.log(`payResult ${params['payResult']} authCode ${params['authCode']} refNo ${params['refNo']}`);
                  for (const serviceItem of this.serviceItems) {
                    try {
                      if (serviceItem) {
                        console.log('serviceItem');
                        console.log(serviceItem);
                        console.log('cid');
                        console.log(this.companyId);
                        const purchase: any = await this.barnsleyImsService.preBasketFind(this.companyId, this.basket, serviceItem);
                        purchase.data.auth_code = params['authCode'];
                        purchase.data.receipt = params['refNo'];
                        purchase.data.agent = true;
                        this.receiptId = purchase.data.receipt;
                        const update: any = await this.barnsleyImsService.preBasketUpdate(this.companyId, this.basket, serviceItem, 'RETURNED_FROM_GATEWAY', purchase.data.receipt, purchase.data);
                        console.log('update');
                        console.log(update);

                        if (purchase) {
                          if (purchase.data && purchase.data.client_id) {
                            //  now we update the details
                            if (purchase.data && purchase.data.auth_token) {
                              localStorage.setItem('auth_token', purchase.data.auth_token);
                            }
                            if (purchase.data.journey_route) {
                              this.datastoreService.journeyRoute = purchase.data.journey_route;
                              const content = this.config?.journey_config?.appointments?.page_content?.[purchase.data.journey_route];
                              this.datastoreService.pageContent = content;

                            }
                            await this.getCompanyQuestions(purchase.data.detail_group);
                            this.selectedSlot = purchase.data.slot;
                            this.datastoreService.extraDuration = purchase.data.extra_duration;
                            await this.availabilityService.setSelectedSlot(this.selectedSlot);
                            this.datastoreService.serviceFees = update.data.extra_items.fees;
                            // now we checkout
                            // const checkout:any = await this.apiService.basketCheckout({id: this.companyId}, {id: this.basket}, {id: purchase.data.client_id});
                            // const checkout = await this.basketService.checkoutBasketV1(this.company, { id: purchase.data.client_id }, false);
                            // console.log('checkout');
                            // console.log(checkout);
                            // await this.afterCheckout(checkout, serviceItem, purchase);
                            const source = interval(2000);
                            const sub = source.subscribe(async (val) => {
                              console.log(`Run ${val}`);
                              if (val < this.retries) {
                                if (!this.bookingMade) {
                                  try {
                                    const found:any = await this.barnsleyImsService.preBasketFind(this.companyId, this.basket, serviceItem);
                                    console.log('found in interval', found);
                                    this.webhookResponseStatus = `COMMON.${found.status}`;
                                    if (found.data) {
                                      if (found.data.auth_code) {
                                        this.chargeId = found.data.auth_code;
                                      }
                                      if (found.ref) {
                                        this.ref = found.ref;
                                      }
                                      if (found.data.receipt) {
                                        this.receipt = found.data.receipt;
                                      }

                                    }
                                    if (!this.chargeId) {
                                      if (params['authCode']) {
                                        this.chargeId = params['authCode'];
                                      }
                                    }
                                    if (!this.receipt) {
                                      if (params['refNo']) {
                                        this.receipt = params['refNo'];
                                      }
                                    }

                                    if (found.status === 'PAID') {
                                      sub.unsubscribe();
                                      const purchase:any = await this.apiService.findPurchase(this.selectedLocation, found.data.purchase_id);
                                      const booking = purchase._embedded.bookings[0];
                                      this.datastoreService.booking = booking;
                                      const service = await this.apiService.getService(this.selectedLocation, booking.service_id);
                                      this.selectedService = service;
                                      this.datastoreService.selectedService = service;
                                      await this.servicesService.set(service);

                                      localStorage.setItem('booking', JSON.stringify(booking));
                                      // set the resource, the date time and the location, the booking all on localstorage
                                      // localStorage.setItem('resource', JSON.stringify(this.selectedResourceObj));
                                      localStorage.setItem('date', JSON.stringify(this.selectedSlot));
                                      localStorage.setItem('location', JSON.stringify(this.selectedLocation));
                                      localStorage.setItem('service', JSON.stringify(this.selectedService));

                                      this.router.navigate(['confirmation']);
                                    }

                                    if (found.status.indexOf('FAILED') !== -1 ) {
                                      sub.unsubscribe();
                                      this.spinner.hide();
                                      this.webhookResponseStatus = '';
                                      this.failed = true;
                                    }

                                  }
                                  catch (err) {
                                    console.error(err);
                                  }
                                  
                                  // if (found.status === 'BOOKING_MADE') {
                                  //   console.log('Booking made!');
                                  //   this.bookingMade = true;
                                  //   const checkout:any = await this.apiService.findPurchase({id: this.companyId}, found.data.purchase_id);
                                  //   this.afterCheckout(checkout, serviceItem, found);
                                  // }
                                }
                              }
                              else {
                                console.error(`Retry limit of ${this.retries} reached`);
                                sub.unsubscribe();
                                this.alertService.error(
                                  this.translateService.instant('COMMON.PAYMENT_MAX_RETRIES_REACHED', {serviceId: params['RecNo']})
                                );
                                this.maxRetriesReached = true;
                                this.spinner.hide();
                              }
                            });
                          }
                          else {
                            console.error(`No client found for ${this.basket} and ${serviceItem}`);
                          }
                        }
                        else {
                          console.error(`No purchase found for ${this.basket} and ${serviceItem}`);
                        }
                      }
                    }
                    catch (err) {
                      console.error(err);
                    }

                  }
                }
                else {
                  this.pageTitle = "Your payment and booking has been cancelled";
                  this.paymentFailed = true;


                  for (const serviceItem of this.serviceItems) {
                    try {
                      if (serviceItem) {
                        console.log('serviceItem', serviceItem);
                        console.log('cid', this.companyId);
                        const purchase: any = await this.barnsleyImsService.preBasketFind(this.companyId, this.basket, serviceItem);

                        if (purchase) {
                          if (purchase.data && purchase.data.client_id) {
                            //  now we update the details

                            if (purchase.data && purchase.data.extra_items && purchase.data.extra_items.lookupResponses) {
                              this.datastoreService.lookupResponses = purchase.data.extra_items.lookupResponses;
                            }

                            if (purchase.data && purchase.data.extra_items && purchase.data.extra_items.selectedAddress) {
                              this.datastoreService.selectedAddress = purchase.data.extra_items.selectedAddress;
                            }

                            if (purchase.data && purchase.data.auth_token) {
                              localStorage.setItem('auth_token', purchase.data.auth_token);
                            }
                            if (purchase.data.journey_route) {
                              this.datastoreService.journeyRoute = purchase.data.journey_route;
                              const content = this.config?.journey_config?.appointments?.page_content?.[purchase.data.journey_route];
                              this.datastoreService.pageContent = content;

                            }
                            // await this.getCompanyQuestions(purchase.data.detail_group);
                            this.selectedSlot = purchase.data.slot;
                            this.datastoreService.extraDuration = purchase.data.extra_duration;
                            // await this.availabilityService.setSelectedSlot(this.selectedSlot);
                            purchase.data.auth_code = params['AuthCode'];
                            purchase.data.receipt = params['RecNo'];
                            this.receiptId = purchase.data.receipt;
                            const update: any = await this.barnsleyImsService.preBasketUpdate(this.companyId, this.basket, serviceItem, 'PAYMENT_FAILED', purchase.data.receipt, purchase.data);
                            console.log('updated', update);
                          }
                          else {
                            console.error(`No client found for ${this.basket} and ${serviceItem}`);
                          }
                        }
                        else {
                          console.error(`No purchase found for ${this.basket} and ${serviceItem}`);
                        }
                      }
                    }
                    catch (err) {
                      console.error(err);
                      this.spinner.hide();
                      this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
                    }
                  }

                  console.error(`Purchase was not successful for ${this.basket}.`);
                  this.spinner.hide();
                  // this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));

                }
              }
            }
          }).catch(err => {
            console.log(err);
            this.spinner.hide();
            this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
          });
        });
      }
    });
  }

  async getCompanyQuestions(detailGroup) {
    this.questionsService.getCompanyQuestions(detailGroup).subscribe((res: any) => {
      // Questions = all questions on the company
      const questions = res.questions;
      this.datastoreService.companyQuestions = questions;
    });
  }

  async afterCheckout(res, serviceItem, purchaseData) {
    console.log('afterCheckout');
    console.log(res);
    const purchase: any = await this.apiService.findPurchase(this.selectedLocation, res.id);
    console.log(purchase);
    purchaseData.data.purchase_id = purchase.id;
    const update: any = await this.barnsleyImsService.preBasketUpdate(this.companyId, this.basket, serviceItem, 'BOOKING_MADE', purchaseData.data.receipt, purchaseData.data);

    const booking = purchase._embedded.bookings[0];
    const member = purchase._embedded.client;
    this.member = member;
    this.datastoreService.booking = booking;
    this.datastoreService.purchase = purchase;
    const service = await this.apiService.getService(this.selectedLocation, booking.service_id);
    await this.servicesService.set(service);
    this.selectedService = service;
    this.datastoreService.selectedService = service;
    // 
    console.log('booking');
    console.log(booking);

    // await this.apiService.sendFrontSheetEmail(booking); // sendCommunicationEmail
    let ceremonyFee;
    try {
      if (this.datastoreService.serviceFees.length > 0) {
        // find ceremony base cost
        const noQuestionId = this.datastoreService.serviceFees.find((item) => item.questionid == undefined);
        console.log('noQuestionId');
        console.log(noQuestionId);
        if (noQuestionId) {
          ceremonyFee = noQuestionId;
          // remove the base cost from the array
          this.datastoreService.serviceFees = this.datastoreService.serviceFees.filter((item) => item.questionid !== undefined);
        }
      }
      console.log('ceremonyFee');
      console.log(ceremonyFee);

      // ceremonyFee = this.datastoreService.serviceFees.shift();
    }
    catch (err) {
      console.log(err);
    }

    let paymentAmount = 0;
    let bookingPrice = 0;
    let chargePrice = 0;
    let certs = 0;
    let foundExtraItemIds = [];
    let foundExtraItemCharges = [];

    let certsToRemoveCount = 0;

    if (!this.datastoreService.isCitizenshipRoute) {
      try {
        // link booking to extra item ONLY IF we are not an admin journey, but we always want to calculate the price.
        if (this.datastoreService.config.hasOwnProperty('journey_config')) {
          if (this.datastoreService.config.journey_config.hasOwnProperty('appointments')) {
            // if (this.datastoreService.config.journey_config.ceremonies.hasOwnProperty('fees_extra_item_id')) {
            //   const extraItem = this.datastoreService.config.journey_config.ceremonies.fees_extra_item_id.trim();
            //   await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem, ceremonyFee);
            // }
            if (this.datastoreService.selectedService.extra?.fees_extra_item_id) {
              const extraItem = this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
              if (extraItem && extraItem.length > 0) {
                // paymentAmount += ceremonyFee.deposit;
                paymentAmount = this.datastoreService.totalCost;
                bookingPrice += ceremonyFeeTotal(ceremonyFee);
                // if (!this.adminJourney) {
                await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem, ceremonyFee);
                // }
              }
            }
            // now link other items
            console.log('serviceFees');
            console.log(this.datastoreService.serviceFees);
            for (const extraItem of this.datastoreService.serviceFees) {
              if (extraItem.questionid) {
                const question = this.datastoreService.companyQuestions.find((q) => q.id == extraItem.questionid);
                if (question) {
                  if (question.help_text) {
                    const schema: any = JSON.parse(question.help_text);
                    if (schema['extra-item']) {
                      const extraItemId = schema['extra-item'];
                      foundExtraItemIds.push(extraItemId);
                      foundExtraItemCharges.push((extraItem.cost * parseInt(extraItem.quantity)));
                      // if (question.id == this.datastoreService.config.journey_config.ceremonies.included_certificates_question) {
                      // paymentAmount += (extraItem.cost * parseInt(extraItem.quantity));
                      // bookingPrice += (extraItem.cost * parseInt(extraItem.quantity));
                      // chargePrice += extraItem.cost;
                      bookingPrice += (extraItem.cost * parseInt(extraItem.quantity));
                      // bookingPrice += extraItem.cost;
                      // }
                      certs++;
                      // Always link extra items
                      // if (!this.adminJourney) {
                      await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItemId, extraItem);
                      // }
                    }
                    else {
                      console.log('Missing extra item');
                    }
                  }
                  else {
                    console.log('Missing schema');
                  }

                }
                else {
                  console.log(`Cant find question ${extraItem.questionid}`);
                  chargePrice += extraItem.cost;
                  bookingPrice += (extraItem.cost * parseInt(extraItem.quantity));
                  await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem.item_id, extraItem);
                }

              }
              else {
                console.log('No question ID on extra item');
                chargePrice += extraItem.cost;
                bookingPrice += (extraItem.cost * parseInt(extraItem.quantity));
                await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem.item_id, extraItem);

              }
            }

          }
        }

      }
      catch (err) {
        console.log(err);
      }
    }
    else {
      // citizenship
      try {
        console.log('totalCost');
        console.log(this.datastoreService.totalCost);
        if (isNaN(this.datastoreService.totalCost)) {
          this.datastoreService.totalCost = 0;
        }
        const extraItem = update.data.extra_items.fees[0].item_id;
        paymentAmount = this.datastoreService.totalCost;
        bookingPrice += ceremonyFee.cost;
        // if (!this.adminJourney) {
        await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem, ceremonyFee);

        // now link other items

        console.log('serviceFees');
        console.log(this.datastoreService.serviceFees);
        for (const extraItem of this.datastoreService.serviceFees) {
          if (extraItem.questionid) {
            const question = this.datastoreService.companyQuestions.find(
              (q) => q.id == extraItem.questionid
            );
            if (question) {
              if (question.help_text) {
                const schema: any = JSON.parse(question.help_text);
                if (schema['extra-item']) {
                  const extraItemId = schema['extra-item'];
                  foundExtraItemIds.push(extraItemId);
                  foundExtraItemCharges.push(
                    extraItem.cost * parseInt(extraItem.quantity)
                  );
                  // if (question.id == this.datastoreService.config.journey_config.ceremonies.included_certificates_question) {
                  // paymentAmount += (extraItem.cost * parseInt(extraItem.quantity));
                  // bookingPrice += (extraItem.cost * parseInt(extraItem.quantity));
                  // chargePrice += extraItem.cost;
                  bookingPrice +=
                    extraItem.cost * parseInt(extraItem.quantity);
                  // bookingPrice += extraItem.cost;
                  console.log('ei bookingPrice');
                  console.log(bookingPrice);
                  paymentAmount +=
                    extraItem.cost * parseInt(extraItem.quantity);
                  console.log('ei paymentAmount');
                  console.log(paymentAmount);
                  // }
                  certs++;
                  // Always link extra items
                  // if (!this.adminJourney) {
                  // await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItemId, extraItem);
                  // }
                } else {
                  console.log('Missing extra item');
                }
              } else {
                console.log('Missing schema');
              }
            } else {
              console.log(`Cant find question ${extraItem.questionid}`);
              chargePrice += extraItem.cost;
              bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
              // await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem.item_id, extraItem);
            }
          } else {
            console.log('No question ID on extra item');
            chargePrice += extraItem.cost;
            bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
            // await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem.item_id, extraItem);
          }
        }
      }
      catch (err) {
        console.error(err);
      }
    }

    if (this.datastoreService.selectedService.extra?.online_payment == 'Yes' && ceremonyFee) {
      try {
        console.log(`Booking price: ${bookingPrice}`);
        // now we update the price of the booking
        await this.apiService.updatePrice(this.selectedLocation, booking.id, purchase.id, `${(bookingPrice * 100)}`, '0');


        localStorage.setItem('booking', JSON.stringify(booking));
        // set the resource, the date time and the location, the booking all on localstorage
        // localStorage.setItem('resource', JSON.stringify(this.selectedResourceObj));
        localStorage.setItem('date', JSON.stringify(this.selectedSlot));
        localStorage.setItem('location', JSON.stringify(this.selectedLocation));
        localStorage.setItem('booking', JSON.stringify(booking));
        localStorage.setItem('service', JSON.stringify(this.selectedService));

        const authToken: string = localStorage.getItem('auth_token');
        console.log('authToken', authToken);
        const extra: any = await this.apiService.getServiceItemExtraLinksForBooking(booking.company_id, booking.id, authToken, this.member.id);
        console.log(extra);
        let payCallNote = '';
        let note = `Payment type: `;
        let hasDeposit = false;
        if (extra && extra.length > 0) {
          for (const item of extra) {
            if (item.item_id !== this.datastoreService.selectedService.extra?.fees_extra_item_id) {
              if (item.data && item.data.quantity) {
                certs = parseInt(item.data?.quantity);
              }
              break;
            }
          }
          for (const item of extra) {
            if (item.item_id === this.datastoreService.selectedService.extra?.fees_extra_item_id) {
              // now we know the deposit and full fee value
              if (item.data.deposit !== item.data.cost) {
                const daysAway = moment(booking.datetime).diff(moment(), 'd');
                if (daysAway > 182) {
                  note = `${note} Appointment Fee Deposit`;
                  payCallNote = `Appointment Fee Deposit`;
                  if (certs > 0) {
                    note = `${note} & Certificates in Full`;
                    payCallNote = `${payCallNote} & Certificates in Full`;
                  }
                  hasDeposit = true;
                }
                else {
                  note = `${note} Appointment`;
                  payCallNote = `Appointment`;
                  if (certs > 0) {
                    note = `${note} Certificates in Full`;
                    payCallNote = `${payCallNote} Certificates in Full`;
                  }
                }
              }
              else {
                note = `${note} Appointment`;
                payCallNote = `Appointment`;
                if (certs > 0) {
                  note = `${note} Certificates in Full`;
                  payCallNote = `${payCallNote} Certificates in Full`;
                }
              }
            }
          }
        }
        // now update the note
        note += ` | Deposit? ${(hasDeposit) ? 'Yes' : 'No'}`;
        if (certs > 0) {
          note += ` | Number of certificates: ${certs}`;
        }
        note += ` | Deposit payment date: ${moment().tz('Europe/London').format("dddd, MMMM Do YYYY")}`;
        note += ` | Deposit payment amount: £${this.amount}`;
        note += ` | Deposit receipt number: ${this.receiptId}`;
        try {
          await this.apiService.payPurchase(this.selectedLocation.id, booking.service_id, booking.purchase_id, {
            amount: this.amount,
            transaction_id: `${this.receiptId}`,
            notify: false,
            notify_admin: false,
            payment_status: 'paid',
            notes: `${payCallNote}`
          }, purchase._embedded.client.id);
          const update2: any = await this.barnsleyImsService.preBasketUpdate(this.companyId, this.basket, serviceItem, 'PAID', purchaseData.data.receipt, purchaseData.data);

        }
        catch (err) {
          console.error(err);
        }

        try {
          await this.apiService.addNoteToBooking(this.selectedLocation, booking.id, note).then(async (body: any) => {
            // Loop over booking.questions and attach images for base64 answers
            for (const key in body.questions) {
              if (body.questions.hasOwnProperty(key)) {
                const question = body.questions[key];

                if (question.answer && typeof question.answer === 'string' && question.answer.startsWith('data:image/')) {
                  try {
                    await this.basketService.attachImageToBooking(
                      booking.purchase_ref,
                      booking.id,
                      question.answer
                    );
                    console.log(`Attached image for question: ${question.name}`);
                  } catch (error) {
                    console.error(`Error attaching image for question: ${question.name}`, error);
                  }
                }
              }
            }
          });
        }
        catch (err) {
          console.error(err);
        }

        // try {
        //   const config: any = this.config;
        //   if (config && config.journey_config && config.journey_config.hasOwnProperty('crm_push')) {
        //     if (config.journey_config.crm_push === 'osc') {
        //       await this.apiService.submitCaseToOracle(this.parent, booking);
        //     }
        //   }
        // }
        // catch (err) {
        //   console.error(err);
        // }

        // if (this.datastoreService.selectedService) {
        //   try {
        //     const dontSendIds = this.config.journey_config.welcome_email_ignore_list;
        //     // dont send emails for these ids
        //     if (!dontSendIds.includes(this.datastoreService.selectedService.global_id)) {
        //       await this.apiService.sendWelcomeEmail(this.selectedLocation.id, member.id);
        //       await this.apiService.bookingTimeline(this.selectedLocation.id, booking.purchase_id, member.id, member.email);
        //     }
        //   }
        //   catch (err) {
        //     console.error(err);
        //   }
        // }

        if (this.datastoreService.adminJourney) {
          try {
            await this.apiService.updateLocation(this.parent);
          }
          catch (err) {
            console.error(err);
          }
        }

        this.router.navigate(['confirmation']);
        return;
      }
      catch (err) {
        console.error(err);
        this.spinner.hide();
        // this.apiService.logPaymentExtra(
        //   this.company,
        //   this.dataStore.selectedService,
        //   booking.purchase_id,
        //   {
        //     "purchase": booking.purchase_id,
        //     "payment_error": err
        //   }
        // );
        this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
        this.router.navigate(['locations']);
      }
    }

  }

  restartJourney() {
    if (sessionStorage.getItem('journey')) {
      this.router.navigate(['start/' + sessionStorage.getItem('journey')])
    }
    else {
      this.router.navigate(['/departments']);
    }
  }

}
